import Vue from 'vue'
import VueRouter from 'vue-router'
import Login from '../components/Login.vue'
import Index from '../components/Index.vue'
import Welcome from '../components/Welcome.vue'
import Welcome1 from '../components/Welcome1.vue'
import NoAccess from '../components/NoAccess.vue'
import StoreList from '../components/Store/Stores.vue'
import StoreAdd from '../components/Store/Add.vue'
import OpenBfAccountOperator from '../components/Finance/BfAccountOperator.vue'
import BfBalanceAudit from '../components/Finance/BfBalanceAudit.vue'
import BfBalanceQkAudit from '../components/Finance/BfBalanceQkAudit.vue'
import OpenBankForm from '../components/Finance/BfBank.vue'
import StoreEdit from '../components/Store/Edit.vue'
import StoreMark from '../components/Store/Mark.vue'
import Swiper from '../components/Store/Swiper.vue'
import Device from '../components/Store/Device.vue'
import UserList from '../components/User/Users.vue'
import RecordList from '../components/User/Records.vue'
import CardList from '../components/Card/Cards.vue'
import StoreCardList from '../components/Card/StoreCardList.vue'
import OrderList from '../components/Order/Orders.vue'
import CardGrantActivityPool from '../components/CardGrant/ActivityPool.vue'
import CardGrantActivityRecords from '../components/CardGrant/ActivityRecords.vue'
import SendPayLogs from '../components/Order/SendPayLogs.vue'
import CxLogs from '../components/Order/CxLogs.vue'
import VerificationRecordList from '../components/Order/VerificationRecords.vue'
import CoachOrderList from '../components/Order/CoachOrders.vue'
import OrderMcList from '../components/OrderMc/Orders.vue'
import DivideList from '../components/Finance/Divide.vue'
import CheckDetail from '../components/Finance/CheckDetail.vue'
import BfBalanceLog from '../components/Finance/BfBalanceLog.vue'
import BfAccount from '../components/Finance/BfAccount.vue'
import DouMeiDivide from '../components/Finance/DouMeiDivide.vue'
import CustomerStoreList from '../components/Store/CustomerStore/StoreList.vue'
import CustomerStoreInfo from '../components/Store/CustomerStore/StoreInfo.vue'
import CustomerUserInfo from '../components/Store/CustomerStore/UserInfo.vue'
import GifExercise from '../components/Exercise/GifExercise.vue' //GIF动图管理
import OwnerConfig from '../components/Profit/OwnerConfig.vue' //店主分润配置
import StoreCostConfig from '../components/Profit/StoreCostConfig.vue' //店铺成本配置
import InvitationRecords from '../components/Invitation/InvitationRecords.vue' //邀请记录
import CardIssueConfig from '../components/Store/CardIssueConfig.vue' //店主发卡配置
import CardIssueRecords from '../components/Store/CardIssueRecords.vue' //发卡记录查询
import CardTypeManage from '../components/Store/CardTypeManage.vue' //卡片类型管理
import RevenueStatistics from '@/components/Statistics/RevenueStatistics.vue' //收入统计
import RevenueWarning from '@/components/Statistics/RevenueWarning.vue' //数据预警
import MeituanAuth from '../components/Store/MeituanAuth.vue' //美团授权管理
import OnlineStatistics from '../components/Store/OnlineStatistics.vue' //在线人数统计
import StoreRefundLink from '../components/Store/RefundLink.vue' //退款联系管理
import QuotaBuyRecords from '../components/Order/QuotaBuyRecords.vue' //额度购买订单
import QuotaBuyRefunds from '../components/Order/QuotaBuyRefunds.vue' //额度退款记录

import CoachList from '../components/Coach/Coachs.vue'

import MerchantList from '../components/Merchant/Merchants.vue' //加盟商列表
import InexpList from '../components/Merchant/Inexplist.vue'    //收支明细
import CashList from '../components/Merchant/Cashlist.vue'    //提现管理

import OpenInfo from '../components/Info/Infos.vue'
import Map from '../components/Store/Map.vue'
import MusicTempManage from '../components/Store/MusicTempManage.vue'// 音频库管理

import bathLog from '../components/System/bathLog.vue' //淋浴记录
import xcxMessage from '../components/System/xcxMessage.vue' //通知管理
import noticeForm from '../components/System/NoticeForm.vue' //新增/编辑通知
import noticeDetail from '../components/System/NoticeDetail.vue' //通知详情
import noticeList from '../components/System/NoticeList.vue' //通知列表
import musicVersion from '../components/System/musicVersion.vue' //音乐版本管理
import ActivityInfo from '../components/System/activityInfo.vue' //活动管理
import Managers from '../components/System/Manager.vue' //设置管理员
import Services from '../components/System/Service.vue' //设置客服
import YeepaySet from '../components/System/YeepaySet.vue' //设置客服
import Systems from '../components/System/System.vue' //系统管理
import LogList from '../components/System/Logs.vue' //日志管理
import Menus from '../components/System/Menus.vue' //菜单管理
import ReleaseNote from '../components/System/ReleaseNote.vue' //发版日志管理
import MiniAppTheme from '../components/System/MiniAppTheme.vue' //小程序主题管理
import ButtonPermissionExample from '../components/example/ButtonPermissionExample.vue' //按钮权限示例
import Roles from '../components/System/Roles.vue' //角色管理
import XcxRoles from '../components/System/XcxRoles.vue' //小程序角色管理
import UserRoles from '../components/System/UserRoles.vue' //用户角色管理
import NfcVideo from '../components/System/nfcVideo.vue' //NFC视频管理
import DashboardConfig from '../components/System/DashboardConfig.vue' //大屏配置
import Message from '../components/Operations/Message.vue' //留言管理
import Trace from '../components/Operations/Trace.vue' //日志追踪
import Faults from '../components/Operations/Fault.vue'    //设备报修管理
import Feedback from '../components/Operations/Feedback.vue'    //意见反馈管理
import SensitiveWords from '../components/Operations/SensitiveWords.vue'    //敏感词管理
import Differ from '../components/Customer/Differ.vue' //异业合作
import Box from '../components/Device/Box.vue' //边缘盒子
import Dahua from '../components/Device/Dahua.vue' //大华摄像头
import Bath from '../components/Device/Bath.vue' //设置淋浴
import BathChargeConfig from '../components/Device/BathChargeConfig.vue' //淋浴付费配置
import OffMemory from '../components/Device/OffMemory.vue' //断电记忆
import DeviceUsr from '../components/Device/DeviceUsr.vue' //USR应急门设备

import Test from '../components/Test.vue'    //测试页

import ClsQuestion from '../components/hardware/ClsQuestion.vue'    //磁力锁问题
import Status from '../components/hardware/Status.vue'    //硬件状态

 // ------------------------加盟商------------------------------
import JoinLogin from '../components/Join/JoinLogin.vue' //加盟商登录
import JoinIndex from '../components/Join/JoinIndex.vue' //加盟商首页
import JoinWelcome from '../components/Join/JoinWelcome.vue' //加盟商欢迎页
import StoreCard from '../components/Join/Setting/StoreCard.vue' //门店上架会员卡
import StoreUsers from '../components/Join/User/Users.vue' //门店会员
import StoreOrder from '../components/Join/Order/Orders.vue' //门店订单
import StoreDiffer from '../components/Join/Customer/Differ.vue' //异业合作
import CoachTx from '../components/Join/CoachTx/CoachTx.vue' //助教提现记录




Vue.use(VueRouter)

const routes = [

  { path: '/test', component:Test, meta: { title: '测试页面' } },
  { path: '/no-access', component:NoAccess, meta: { title: '无权限访问' } },
  { path: '/login', name: 'login', component:Login, meta: { title: '登录' } },
  { path: '/', redirect: '/login' },
  { path: '/admin', redirect: '/login' },
  { path: '*', redirect: '/login' }, // 添加通配符路由，确保所有未匹配的路径都重定向到登录页
  { path: '/index', component: Index, meta: { title: '首页' }, children:[
    { path:'/welcome', component:Welcome, meta: { title: '欢迎页' }},
    { path:'/welcome1', component:Welcome1, meta: { title: '欢迎页' }},
    { path:'/stores', component:StoreList, meta: { title: '门店列表' }},//门店列表
    { path:'/invitation-records', component:InvitationRecords, meta: { title: '邀请记录' }},//邀请记录
    { path:'/storeadd', component:StoreAdd, meta: { title: '添加门店' }},//添加门店
    { path:'/openBfAccountOperator', component:OpenBfAccountOperator, meta: { title: '开户操作' }},//操作开户
    { path:'/bfBalanceLog', component:BfBalanceLog, meta: { title: '宝付资金' }},//操作开户
    { path:'/bfBalanceAudit', component:BfBalanceAudit, meta: { title: '提现审核' }},//提现审核
    { path:'/bfBalanceQkAudit', component:BfBalanceQkAudit, meta: { title: '欠款审核' }},//提现审核
    { path:'/openBankForm', component:OpenBankForm, meta: { title: '银行开户' }},//银行开户
    { path:'/storeedit/:id', component:StoreEdit, meta: { title: '编辑门店' }},//编辑门店
    { path:'/storemark/:id', component:StoreMark, meta: { title: '标注门店' }},//标注门店
    { path:'/swiper', component:Swiper, meta: { title: '轮播图' }},//轮播图
    { path:'/store-refund-link', component:StoreRefundLink, meta: { title: '退款联系管理' }},//退款联系管理
    { path:'/device', component:Device, meta: { title: '器械列表' }},//器械列表
    { path:'/device/:id', component:Device, meta: { title: '器械列表' }},//带ID参数的器械列表
    { path:'/users', component:UserList, meta: { title: '用户列表' }},//用户列表
    { path:'/records', component:RecordList, meta: { title: '进出记录列表' }},//进出记录列表
    { path:'/cards', component:CardList, meta: { title: '会员卡列表' }},//会员卡列表
    { path:'/storecardlist', component:StoreCardList, meta: { title: '店铺卡列表' }},//店铺卡列表
    { path:'/orders', component:OrderList, meta: { title: '订单列表' }},//订单列表
    // 发卡活动池与活动发卡记录不在左侧菜单中，入口在订单列表；
    // activeMenu 指回「订单列表」，否则进入这两个页面时左侧菜单会整体失高亮
    { path:'/card-grant-activity', component:CardGrantActivityPool, meta: { title: '发卡活动池', activeMenu: '/orders' }},//发卡活动池
    { path:'/card-grant-activity-records/:id', component:CardGrantActivityRecords, meta: { title: '活动发卡记录', activeMenu: '/orders' }},//活动发卡记录
    { path:'/sendPayLogs', component:SendPayLogs, meta: { title: '发起支付列表' }},//发起支付列表
    { path:'/auditPayRefund', component:CxLogs, meta: { title: '审核支付退款列表' }},//发起支付列表
    { path:'/verificationrecords', component:VerificationRecordList, meta: { title: '核销列表' }},//团购核销列表
    { path:'/quota-buy-records', component:QuotaBuyRecords, meta: { title: '额度购买订单' }},//额度购买订单
    { path:'/quota-buy-refunds', component:QuotaBuyRefunds, meta: { title: '额度退款记录' }},//额度退款记录
    { path:'/coachOrders', component:CoachOrderList, meta: { title: '助教订单列表' }},//助教订单列表
    { path:'/mcorders', component:OrderMcList, meta: { title: '模拟订单' }},//模拟订单
    { path:'/divides', component:DivideList, meta: { title: '分账明细' }},//分账明细
    { path:'/checkdetail', component:CheckDetail, meta: { title: '对账明细' }},//对账明细
    { path:'/openBfAccount', component:BfAccount, meta: { title: '开户管理' }},//开户管理
    { path:'/doumeidivide', component:DouMeiDivide, meta: { title: '抖美分账' }},//抖美分账
    { path:'/coachs', component:CoachList, meta: { title: '助教列表' }},//助教列表
    { path:'/customer-stores', component:CustomerStoreList, meta: { title: '客服门店列表' }, alias: '/storelist' },//客服门店列表
    { path:'/customer-store-info/:id', component:CustomerStoreInfo, meta: { title: '客服门店详情' }},//客服门店详情
    { path:'/customer-user-info/:storeId', component:CustomerUserInfo, meta: { title: '客服用户信息' }},//客服用户信息
    { path:'/userinfo', component:CustomerUserInfo, meta: { title: '会员详情' }},//会员详情页面
    { path:'/merchants', component:MerchantList, meta: { title: '加盟商列表' }},   //加盟商列表
    { path:'/inexplist', component:InexpList, meta: { title: '收支明细' }},   //加盟商收支明细淋浴
    { path:'/cashlist', component:CashList, meta: { title: '提现管理' }},   //加盟商提现管理
    { path:'/activityInfo', component:ActivityInfo, meta: { title: '活动设置' }},   //活动管理
    { path:'/bathLog', component:bathLog, meta: { title: '淋浴记录' }},   //淋浴记录
    { path:'/xcxMessage', component:xcxMessage, meta: { title: '通知管理' }},   //通知管理
    { path:'/noticeList', component:noticeList, meta: { title: '通知列表' }},   //通知列表
    { path:'/noticeForm', component:noticeForm, meta: { title: '新增/编辑通知' }},   //新增/编辑通知
    { path:'/noticeDetail/:id', component:noticeDetail, meta: { title: '通知详情' }},   //通知详情
    { path:'/musicVersion', component:musicVersion, meta: { title: '音乐版本管理' }},   //通知管理
    { path:'/managers', component:Managers, meta: { title: '管理员设置' }},   //设置管理员
    { path:'/services', component:Services, meta: { title: '客服设置' }},   //设置客服
    { path:'/yeepayset', component:YeepaySet, meta: { title: '易宝分账设置' }},   //设置易宝分帐
    { path:'/gifexercise', component:GifExercise, meta: { title: 'GIF动图管理' }},//GIF动图管理
    { path:'/owner-config', component:OwnerConfig, meta: { title: '店主分润配置' }},//店主分润配置
    { path:'/cost-config', component:StoreCostConfig, meta: { title: '店铺成本配置' }},//店铺成本配置
    { path:'/card-issue-config', component:CardIssueConfig, meta: { title: '店主发卡配置' }},//店主发卡配置
    { path:'/card-issue-records', component:CardIssueRecords, meta: { title: '发卡记录查询' }},//发卡记录查询
    { path:'/card-type-manage', component:CardTypeManage, meta: { title: '卡片类型管理' }},//卡片类型管理
    { path:'/cls-question', component:ClsQuestion, meta: { title: '磁力锁问题' }},//磁力锁问题
    { path:'/hard-status', component:Status, meta: { title: '硬件状态' }},//硬件状态


    { path:'/systems', component:Systems, meta: { title: '协议设置' }},   //协议设置
    { path:'/logs', component:LogList, meta: { title: '日志管理' }},   //日志管理
    { path:'/menus', component:Menus, meta: { title: '菜单管理' }},   //菜单管理
    { path:'/release-note', component:ReleaseNote, meta: { title: '发版日志管理' }},   //发版日志管理
    { path:'/miniAppTheme', component:MiniAppTheme, meta: { title: '小程序主题管理' }},   //菜单管理
    { path:'/permission-example', component:ButtonPermissionExample, meta: { title: '权限示例' }},   //权限示例
    { path:'/roles', component:Roles, meta: { title: '角色管理' }},   //角色管理
    { path:'/xcxRoles', component:XcxRoles, meta: { title: '小程序角色管理' }},   //角色管理
    { path:'/userroles', component:UserRoles, meta: { title: '用户角色管理' }},   //用户角色管理
    { path:'/nfcVideo', component:NfcVideo, meta: { title: 'NFC视频管理' }},   //NFC视频管理
    { path:'/dashboardConfig', component:DashboardConfig, meta: { title: '大屏配置' }},   //大屏配置
    { path:'/messages', component:Message, meta: { title: '留言管理' }},   //留言管理
    { path:'/trace', component:Trace, meta: { title: '日志追踪' }},   //日志追踪
    { path:'/faults', component:Faults, meta: { title: '设备报修管理' }},   //设备报修管理
    { path:'/feedback', component:Feedback, meta: { title: '意见反馈管理' }},   //意见反馈管理
    { path:'/sensitivewords', component:SensitiveWords, meta: { title: '敏感词管理' }},   //敏感词管理
    { path:'/map', component:Map, meta: { title: '地图' }},//地图
    { path:'/openinfo', component:OpenInfo, meta: { title: '信息管理' }},   //信息管理
    { path:'/musicTempManage', component:MusicTempManage, meta: { title: '音频库管理' }},   //音频库管理
    { path:'/differ', component:Differ, meta: { title: '异业合作' }},   //异业合作
    { path:'/box', component:Box, meta: { title: '边缘盒子' }},//边缘盒子
    { path:'/dahua', component:Dahua, meta: { title: '大华摄像头' }},//大华摄像头
    { path:'/bath', component:Bath, meta: { title: '设置淋浴' }},//设置淋浴
    { path:'/bathChargeConfig', component:BathChargeConfig, meta: { title: '淋浴付费配置' }},//配置淋浴收费
    { path:'/offmemory', component:OffMemory, meta: { title: '断电记忆' }},//断电记忆
    { path:'/deviceUsr', component:DeviceUsr, meta: { title: '有人应急门' }},//USR应急门设备
    { path:'/revenue-statistics', component:RevenueStatistics, meta: { title: '收入统计' }},//收入统计
    { path:'/revenue-warning', component:RevenueWarning, meta: { title: '数据预警' }},//数据预警
    { path:'/meituan-auth', component:MeituanAuth, meta: { title: '美团授权管理' }},//美团授权管理
    { path:'/online-statistics', component:OnlineStatistics, meta: { title: '在线人数统计' }},//在线人数统计
  ]},

 // ------------------------加盟商------------------------------
  { path: '/store', component:JoinLogin, meta: { title: '加盟商登录' } },
  { path: '/joinindex', component: JoinIndex, redirect:'/joinwelcome', meta: { title: '加盟商首页' }, children:[
    { path:'/joinwelcome', component:JoinWelcome, meta: { title: '加盟商欢迎页' }},
    { path:'/storecard', component:StoreCard, meta: { title: '门店上架会员卡' }},//门店上架会员卡
    { path:'/storeusers', component:StoreUsers, meta: { title: '会员管理' }},//会员管理
    { path:'/storeorder', component:StoreOrder, meta: { title: '订单管理' }},//订单管理
    { path:'/storediffer', component:StoreDiffer, meta: { title: '拓客管理' }},//拓客管理
    { path:'/coachTx', component:CoachTx, meta: { title: '提现记录' }},//提现记录
  ]},

]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

// 全局处理NavigationDuplicated错误
// 重写原型对象上的push和replace方法
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace

// 重写push方法
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      // 只有当错误不是导航重复时才抛出
      return Promise.reject(err)
    }
    // 导航重复错误静默处理
    return Promise.resolve()
  })
}

// 重写replace方法
VueRouter.prototype.replace = function replace(location) {
  return originalReplace.call(this, location).catch(err => {
    if (err.name !== 'NavigationDuplicated') {
      // 只有当错误不是导航重复时才抛出
      return Promise.reject(err)
    }
    // 导航重复错误静默处理
    return Promise.resolve()
  })
}


router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  // 清除可能存在的API路径导航状态
  // 这是为了解决API请求路径与前端路由路径混淆的问题
  if (window.sessionStorage.getItem('lastApiPath') && !to.path.includes('/full_info')) {
    console.log('清除上一次API请求路径状态');
    window.sessionStorage.removeItem('lastApiPath');
    window.sessionStorage.removeItem('isApiRequest');
  }

  // 全局路径处理 - 确保所有路径都是绝对路径
  // 第1步：检查目标路径是否为相对路径（不以/开头）
  if (to.fullPath && !to.fullPath.startsWith('/')) {
    console.log('检测到相对路径，转换为绝对路径:', to.fullPath);
    return next('/' + to.fullPath);
  }

  // 第2步：特别处理从动态路由段（如/customer-store-info/:id）导航的情况
  // 这里我们检查是否从任何动态路由段导航出去
  if (from.path) {
    // 特别处理从/customer-store-info/:id路径导航的情况
    const isFromCustomerStoreInfo = from.path.includes('/customer-store-info/');

    // 检查是否从带有动态参数的路由导航（如/xxx/:id形式）
    // 使用更精确的正则表达式匹配动态路由模式
    const isDynamicRoutePattern = /\/[\w-]+\/[\w\d-]+/.test(from.path) ||
                                  from.path.match(/\/[\w-]+-[\w-]+-[\w-]+\/\d+/) !== null;

    // 如果是从动态路由导航，确保目标路径是绝对路径
    if ((isDynamicRoutePattern || isFromCustomerStoreInfo)) {
      // 检查to.path是否为相对路径（不以/开头）
      if (to.path && !to.path.startsWith('/')) {
        // 强制使用绝对路径
        const absolutePath = '/' + to.path;
        console.log('检测到相对路径，转换为绝对路径:', absolutePath);
        return next(absolutePath);
      }

      // 特别处理从 customer-store-info 导航到其他路径的情况
      if (isFromCustomerStoreInfo) {
        // 检查目标路径是否包含当前路径的前缀
        // 例如：从 /customer-store-info/3 导航到 /customer-store-info/cards
        if (to.path.startsWith('/customer-store-info/') && !to.path.match(/\/customer-store-info\/\d+$/)) {
          // 提取真正的目标路径（去掉前缀）
          const pathSegments = to.path.split('/');
          const lastSegment = pathSegments[pathSegments.length - 1];
          const correctPath = '/' + lastSegment;
          console.log('从 customer-store-info 导航到其他路径，修正路径为:', correctPath);
          return next(correctPath);
        }

        console.log('从 customer-store-info/:id 导航到其他路径:', to.path);
      } else if (isDynamicRoutePattern) {
        console.log('从动态路由导航到其他路径:', to.path);
      }

      // 如果目标路径也是多级路由且包含数字部分（如/xxx/123），则去掉数字部分
      if (to.path.match(/\/[\w-]+\/\d+$/)) {
        // 提取基本路径（去掉数字部分）
        const baseRoutePath = to.path.replace(/\/\d+$/, '');
        console.log('检测到目标路径也是动态路由，去掉数字部分:', baseRoutePath);
        return next(baseRoutePath);
      }
    }
  }

  // 如果是登录页面，直接放行
  if (to.path === '/login' || to.path === '/store') {
    return next();
  }

  // 如果是无权限页面，直接放行
  if (to.path === '/no-access') {
    return next();
  }

  // 公共路径和登录页直接放行 - 确保这些路径完全放行，不进行后续token检查
  const publicPaths = ['/login', '/admin', '/no-access', '/customer-stores', '/'];
  const publicPathPrefixes = ['/test', '/store', '/customer-store-info/', '/customer-user-info/'];

  // 检查是否是公共路径
  if (publicPaths.includes(to.path) || publicPathPrefixes.some(prefix => to.path.startsWith(prefix))) {
    console.log('公共路径放行:', to.path);
    return next();
  }

  // 检查token
  const tokenStr = window.sessionStorage.getItem('admin_token');
  const jointokenStr = window.sessionStorage.getItem('join_token');
  const loginToken = window.sessionStorage.getItem('login_token');

  console.log('Token状态:', { tokenStr, jointokenStr, loginToken });

  // 如果没有token，重定向到登录页
  if (!tokenStr && !jointokenStr && !loginToken) {
    console.log('未找到有效token，重定向到登录页');
    return next('/login');
  }

  // 检查是否是超级管理员
  const rolesStr = window.sessionStorage.getItem('roles');
  const nameToken = window.sessionStorage.getItem('name_token');
  const username = window.sessionStorage.getItem('username');

  // 调试信息
  console.log('当前用户名:', nameToken, username);
  console.log('角色信息:', rolesStr);

  // admin用户或超级管理员拥有所有权限
  if (nameToken === 'admin' || username === 'admin') {
    console.log('admin用户，拥有所有权限');
    return next();
  }

  if (rolesStr) {
    try {
      const roles = JSON.parse(rolesStr);
      // 超级管理员有所有权限
      if (roles.includes('超级管理员')) {
        console.log('超级管理员用户，拥有所有权限:', roles);
        return next();
      }
    } catch (error) {
      console.error('解析角色错误:', error);
    }
  }

  // 获取菜单权限信息（新的RBAC系统）
  const menuListStr = window.sessionStorage.getItem('menuList');
  let userMenuPermissions = [];

  // 收集用户的菜单权限代码 - 将函数定义提升到外部
  function collectPermissions(menus) {
    if (!menus || !Array.isArray(menus)) return [];

    let permissions = [];
    menus.forEach(menu => {
      if (menu.permissionCode) {
        permissions.push(menu.permissionCode);
      }
      if (menu.children && menu.children.length > 0) {
        permissions = permissions.concat(collectPermissions(menu.children));
      }
    });
    return permissions;
  }

  if (menuListStr) {
    try {
      const menuList = JSON.parse(menuListStr);
      userMenuPermissions = collectPermissions(menuList);
      console.log('用户菜单权限:', userMenuPermissions);
    } catch (error) {
      console.error('解析菜单权限错误:', error);
    }
  }

  // 如果没有菜单权限，尝试使用旧的权限系统作为兜底
  if (userMenuPermissions.length === 0) {
    const adminPermissions = window.sessionStorage.getItem('perid_token');
    if (adminPermissions && adminPermissions.trim() !== '') {
      try {
        // 解析权限数据
        const permissions = JSON.parse(adminPermissions.replace(/'/g, '"')); // 替换单引号为双引号并解析
        userMenuPermissions = permissions;
        console.log('使用旧权限系统:', userMenuPermissions);
      } catch (error) {
        console.error('旧权限解析错误:', error);
      }
    }
  }

  // 如果仍然没有权限信息，允许导航（可能是刚登录的用户）
  if (userMenuPermissions.length === 0) {
    console.log('没有找到权限信息，允许导航');
    return next();
  }

  // 路由与权限的对应关系
  const routePermissionsMap = {
    // 首页也需要权限才能访问
    '/welcome': 'menu:home:welcome',
    '/welcome1': 'menu:home:welcome',
    // 门店管理模块
    '/stores': 'menu:store:stores',
    '/storeadd': 'menu:store:add',
    '/storeedit': 'menu:store:stores',
    '/storemark': 'menu:store:map',
    '/swiper': 'menu:store:banner',
    '/device': 'menu:store:device',
    '/store-refund-link': 'menu:store:refundlink',
    '/map': 'menu:store:map',
    // 会员管理模块
    '/users': 'menu:user:users',
    '/records': 'menu:user:records',
    // 会员卡管理模块
    '/card-issue-config': 'store:cardissue:config',
    '/card-issue-records': 'store:cardissue:records',
    '/card-type-manage': 'store:cardtype:manage',
    // 订单管理模块
    '/orders': 'menu:order:orders',
    '/sendPayLogs': 'menu:order:sendPayLogs',
    '/auditPayRefund': 'menu:order:auditPayRefund',
    '/verificationrecords': 'menu:order:verification',
    '/quota-buy-records': 'menu:order:quotabuyorders',
    '/quota-buy-refunds': 'menu:order:quotabuyrefunds',
    '/coachOrders': 'menu:coachOrder:orders',
    '/mcorders': 'menu:order:mock',
    // 财务管理模块
    '/divides': 'menu:finance:divide',
    '/checkdetail': 'menu:finance:check',
    '/openBfAccount': 'menu:finance:bf',
    '/bfBalanceLog': 'menu:finance:bf:balance',
    '/openBfAccountOperator': 'menu:finance:bf:operator',
    '/bfBalanceAudit': 'menu:bf:balance:audit',
    '/bfBalanceQkAudit': 'menu:bf:balanceQk:audit',
    '/openBankForm': 'menu:finance:bf:operator',
    '/doumeidivide': 'menu:finance:doumei',
    // 助教管理模块
    '/coachs': 'menu:coach:coaches',
    // 加盟商管理模块
    '/merchants': 'menu:merchant:merchants',
    '/inexplist': 'menu:merchant:inexp',
    '/cashlist': 'menu:merchant:cash',
    // 系统管理模块
    '/activityInfo': 'menu:system:activityInfo',
    '/bathLog': 'menu:system:bathLog',
    '/xcxMessage': 'menu:system:xcxMessage',
    '/noticeList': 'menu:system:xcxMessage',
    '/noticeForm': 'menu:system:xcxMessage',
    '/noticeDetail': 'menu:system:xcxMessage',
    '/musicVersion': 'menu:system:musicVersion',
    '/managers': 'menu:admin:list',
    '/services': 'menu:system:service',
    '/yeepayset': 'menu:system:yeepay',
    '/systems': 'menu:system:settings',
    '/logs': 'menu:system:logs',
    '/menus': 'menu:menu:list',
    '/release-note': 'releaseNote:list',
    '/miniAppTheme': 'menu:miniAppTheme:list',
    '/permission-example': 'menu:system:permission',
    '/roles': 'menu:role:list',
    '/xcxRoles': 'menu:xcxRole:list',
    '/userroles': 'menu:system:userroles',
    '/nfcVideo': 'menu:system:nfcVideo',
    '/dashboardConfig': 'menu:system:dashboardConfig',
    // 运营管理模块
    '/trace': 'menu:operations:trace',
    '/messages': 'menu:operations:messages',
    '/faults': 'menu:operations:faults',
    '/feedback': 'menu:operations:feedback',
    '/sensitivewords': 'menu:operations:sensitivewords',
    // 信息管理模块
    '/openinfo': 'menu:info:list',
    '/musicTempManage': 'menu:musicTempManage:list',
    // 异业合作
    '/differ': 'menu:customer:differ',
    // 客服门店模块
    '/customer-stores': 'menu:customer-store:list',
    '/customer-store-info': 'menu:customer-store:info',
    // 设备管理模块
    '/box': 'menu:device:box',
    '/dahua': 'menu:device:dahua',
    '/bath': 'menu:device:bath',
    '/bathChargeConfig': 'menu:device:bathChargeConfig',
    '/offmemory': 'menu:device:offmemory',
    '/deviceUsr': 'menu:device:usr',
      // 健身动作管理模块
    '/gifexercise': 'menu:exercise:manage',
      // 磁力锁问题模块
    '/cls-question': 'menu:clsquestion:manage',
      // 硬件状态模块
    '/hard-status': 'menu:hardware:manage',
      // 数据统计模块
    '/revenue-statistics': 'menu:statistics:revenue',
      // 数据预警模块
    '/revenue-warning': 'menu:statistics:warning',
      // 美团授权管理
    '/meituan-auth': 'menu:store:meituan-auth',
  };

  // 打印调试信息
  console.log('当前路由:', to.path);
  console.log('用户权限:', userMenuPermissions);

  // 获取当前路由的基本路径（处理带参数的路由）
  let basePath = to.path;

  // 处理带参数的路由，如 /storeedit/device 应该检查 /storeedit 的权限
  if (to.path.includes('/storeedit/')) {
    basePath = '/storeedit';
  } else if (to.path.includes('/device/')) {
    basePath = '/device';
  } else if (to.path.includes('/customer-store-info/')) {
    basePath = '/customer-store-info';
  } else if (to.path.includes('/card-grant-activity-records/')) {
    basePath = '/card-grant-activity-records';
  }

  // 检查是否是从编辑门店页面导航到其他页面
  const fromPath = from.path;
  const navigatingFromStoreEdit = window.sessionStorage.getItem('navigatingFromStoreEdit');
  const targetRoute = window.sessionStorage.getItem('targetRoute');
  const lastApiPath = window.sessionStorage.getItem('lastApiPath');

  // 检查是否是API请求引起的路由变化
  const isApiRequest = window.sessionStorage.getItem('isApiRequest');

  // 检查当前URL是否包含API路径
  const currentUrl = window.location.href;
  const isFullInfoInUrl = currentUrl.includes('/stores/full_info');

  // 增加调试日志，帮助追踪问题
  console.log('路由导航状态:', {
    to: to.path,
    from: from.path,
    lastApiPath,
    isApiRequest,
    isFullInfoInUrl,
    currentUrl
  });

  // 如果目标路由是正常的前端路由，且不是API路径，则允许导航
  // 这样可以确保用户可以正常导航到其他页面
  if (to.matched && to.matched.length > 0 && !to.path.includes('/full_info')) {
    console.log('导航到有效的前端路由，允许导航:', to.path);
    // 清除可能存在的API路径状态，防止影响后续导航
    window.sessionStorage.removeItem('lastApiPath');
    window.sessionStorage.removeItem('isApiRequest');
    return next();
  }

  // 处理API路径冲突的情况
  if ((lastApiPath && lastApiPath.includes('full_info')) || isFullInfoInUrl) {
    console.log('检测到API请求路径与路由冲突，阻止路由跳转');

    // 如果当前URL包含full_info，需要修正URL
    if (isFullInfoInUrl) {
      console.log('URL中包含API路径，需要修正');
      // 清除相关标记
      window.sessionStorage.removeItem('lastApiPath');
      window.sessionStorage.removeItem('isApiRequest');

      // 如果有上一个有效路由，则重定向回去
      if (from.path && from.path !== '/' && !from.path.includes('/full_info')) {
        console.log('重定向回上一个有效路由:', from.path);
        return next(from.path);
      } else {
        // 否则重定向到首页
        console.log('重定向到首页');
        return next('/welcome');
      }
    }

    // 如果是API请求中，允许正常导航
    if (isApiRequest === 'true') {
      console.log('API请求进行中，允许正常导航');
      return next();
    }

    // 如果是API请求引起的路由变化，则重定向到上一个有效路由
    if (from.path && from.path !== '/' && !from.path.includes('/full_info')) {
      console.log('重定向回上一个有效路由:', from.path);
      return next(from.path);
    } else {
      // 如果上一个路由也无效，则重定向到首页
      console.log('重定向到首页');
      return next('/welcome');
    }
  }

  // 检查是否是从编辑门店页面导航出来的
  if (fromPath.includes('/storeedit/') || navigatingFromStoreEdit === 'true') {
    console.log('从编辑门店页面导航到其他页面，允许访问');

    // 如果是从编辑门店页面导航到其他页面，直接允许导航
    // 如果目标路由与当前路由匹配，清除标记
    if (targetRoute && to.path === '/' + targetRoute) {
      console.log('到达目标路由，清除导航标记');
      window.sessionStorage.removeItem('navigatingFromStoreEdit');
      window.sessionStorage.removeItem('targetRoute');
    }

    return next();
  }

  // 可以根据需要添加更多的路由匹配规则

  // 获取当前路由所需的权限
  const requiredPermission = routePermissionsMap[basePath];

  console.log('路由权限映射表:', routePermissionsMap);
  console.log('当前路由基本路径:', basePath);
  console.log('所需权限:', requiredPermission);

  // 如果路由不需要特殊权限，直接通过
  if (!requiredPermission) {
    console.log('路由无需特殊权限，允许访问');
    return next();
  }

  // 检查用户是否有所需权限
  if (basePath === '/welcome' || basePath === '/welcome1') {
    // 特殊处理首页权限
    if (userMenuPermissions.includes('menu:home:welcome') || userMenuPermissions.includes('menu:index:welcome')) {
      console.log('首页权限检查通过，允许访问');
      return next();
    } else {
      console.log('用户缺少首页权限');
      return next('/no-access');
    }
  } else if (!userMenuPermissions.includes(requiredPermission)) {
    console.log('用户缺少权限:', requiredPermission);
    return next('/no-access'); // 跳转到无权限提示页
  }

  console.log('权限检查通过，允许访问');

  // 通过所有检查，允许导航
  next();
});

export default router
